import React from "react";
import styled from "styled-components";

import { Tag } from "../model/tag/Tag";
import { Rounded } from "../theme/Rounded";
import { Spacing } from "../theme/Spacing";
import { isLightColor } from "../utils/Color";
import { FontSize } from "./Text";

const Chip = styled.span<{ $color: string; $light: boolean }>`
  display: inline-flex;
  align-items: center;
  max-width: 10rem;
  padding: 0.1rem ${Spacing.s};
  border-radius: ${Rounded.pill};
  background-color: ${({ $color }) => $color};
  color: ${({ theme, $light }) => ($light ? theme.black : theme.white)};
  font-size: ${FontSize.xs};
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
`;

/** Just the tag's color, for lists that name the tag beside it */
export const TagDot = styled.span<{ $color: string }>`
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
  border-radius: ${Rounded.circle};
  background-color: ${({ $color }) => $color};
`;

type TagChipProps = {
  tag: Pick<Tag, "name" | "color">;
  dataTestId?: string;
};

export const TagChip: React.FC<TagChipProps> = ({ tag, dataTestId }) => (
  <Chip
    $color={tag.color}
    $light={isLightColor(tag.color)}
    title={tag.name}
    data-testid={dataTestId}
  >
    {tag.name}
  </Chip>
);
